// We have a known issue with broken Next.js middlewares when using embedded mode. We are working on a fix.
// FIXME: PWA-1316 Remove the Embedded Mode enforcement workaround

const forceEmbeddedMode = process.env.ENFORCE_EMBEDDED_MODE === 'true';

export const isEmbeddedModeEnforced = () => forceEmbeddedMode;

export const EMBEDDED_PATH = '/embedded/';
